// Designer that is pulled in from the BE
export interface Designer {
  id?: number,
  name: string,
  description: string,
  website: string,
  address1: string,
  address2: string,
  city: string,
  zipcode: string,
  state: string,
  phone: string,
  imageurls: string[]
}

export const generateEmptyDesigner = (): Designer => ({
  name: '',
  description: '',
  website: '',
  address1: '',
  address2: '',
  city: '',
  zipcode: '',
  state: '',
  phone: '',
  imageurls: []
})
